import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("timesheetCodes")
export class TimesheetCode extends BaseEntity {
  code: string;
  description: string;
}
